import { createStyles, withStyles, WithStyles } from '@material-ui/styles';
import React from 'react';
import { JupiterTheme } from '../../theme/types';
import { J1QLResultData } from '../../../types/J1QL';

const styles = (theme: JupiterTheme) =>
  createStyles({
    rawJson: {
      height: '100%',
      color: theme.palette.primary.main,
      fontFamily: `'Ubuntu Mono', monospace`,
      margin: 0,
      padding: theme.spacing(1.5, 3, 3),
      overflow: 'auto',
    },
  });

interface Props extends WithStyles<typeof styles> {
  result: J1QLResultData;
}

const RawJsonView = ({ result, classes }: Props) => (
  <pre className={classes.rawJson}>{JSON.stringify(result, null, 4)}</pre>
);

export default withStyles(styles)(RawJsonView);
